import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
const LINE_HEIGHT = {
  tiny: 'var(--wds-font-line-height-body-tiny)',
  small: 'var(--wds-font-line-height-body-small)',
  medium: 'var(--wds-font-line-height-body-medium)'
};
const WIDTH = '180px';
export const PerceptionNotePlaceholder = _ref => {
  let {
    size = 'tiny',
    dataHook = 'perception-note-placeholder'
  } = _ref;
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light"
  }, /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    width: WIDTH,
    height: LINE_HEIGHT[size]
  })));
};
//# sourceMappingURL=PerceptionNotePlaceholder.js.map